import 'mapbox-gl/dist/mapbox-gl.css';
import React, { Component } from 'react';
import ReactMapGL, { Marker } from 'react-map-gl';
import arrowNavigation from '../../assets/icons/arrow-navigation.png';
import './Map.scss';
import PolylineOverlay from './PolylineOverlay';


const markerSize = 24,
	zoom = 13.5;

class Map extends Component {
	state = {
		viewport: {
			width: '100%',
			height: '100%',
			latitude: this.props.data.lat ,
			longitude: this.props.data.lon,
			bearing: this.props.data.h,
			zoom: zoom,
			mapboxApiAccessToken: process.env.REACT_APP_MAPBOX_API_ACCESS_TOKEN
		}
	};

	componentDidUpdate(prevProps, prevState){
		if (this.props.data && (
				this.props.data.lat !== this.state.viewport.latitude ||
				this.props.data.lon !== this.state.viewport.longitude ||
				this.props.data.h !== this.state.viewport.bearing
			))
		{
			this.setState({
				viewport: {
					...this.state.viewport,
					longitude: this.props.data.lon,
					latitude: this.props.data.lat,
					bearing: this.props.data.h,
					pitch: 60
				}
			})
		}
	}

	render() {
		return (
			<div className="mapWrapper flex">
				<div className={`mapWrapper__content`}>
					<div className={`map`}>
						<ReactMapGL
							{...this.state.viewport}
							longitude={this.state.viewport.longitude}
							mapStyle={"mapbox://styles/mariodelgado/cjr0znxla8mzt2sntb0a2wmmn"}
							onViewportChange={(viewport) => this.setState({viewport})}
						>
							<PolylineOverlay points={this.props.routePoints} />

							<Marker
								latitude={this.state.viewport.latitude}
								longitude={this.state.viewport.longitude}
								offsetLeft={-markerSize/2}
								offsetTop={-markerSize/2}
								className="mapWrapper__content__marker"
							>
								<img
									src={arrowNavigation}
									alt={`navigation`}
									width={markerSize}
									height={markerSize}
								/>
							</Marker>


						</ReactMapGL>
						<div className={`mapOverlay`}>

						<div className="speed layout-column layout-align-center-center">
							<div className="speed__value">{this.props.speed || '-'}</div>
							<div className="speed__unit">KPH</div>
						</div>

						</div>
						<div className={`mapArc mapArc--left`}>
							<div className={`mapArc__curve mapArc__curve--left`}></div>
						</div>
						<div className={`mapArc mapArc--right`}>
							<div className={`mapArc__curve  mapArc__curve--right`}></div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Map;
